/**
 * Helpers da tela Tributárias (Parametrizações) —
 * alinhados ao protótipo `definicao/esocial-tributacoes.txt`.
 */

/** Converte texto BR (32.420,00 / 5,80% / 5.8) em número. */
export function parseValorNumerico(texto) {
  let s = String(texto ?? "")
    .trim()
    .replace("%", "")
    .replace(/\s/g, "")
    .replace(/R\$\s?/i, "");
  if (!s) return NaN;
  if (s.includes(",")) {
    s = s.replace(/\./g, "").replace(",", ".");
  }
  const valor = Number(s);
  return Number.isFinite(valor) ? valor : NaN;
}

/** Monetário para input: 32420 → "32.420,00" */
export function formatarMoedaInput(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Percentual para input: 5.8 → "5,80" */
export function formatarPctInput(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Máscara monetária enquanto digita (centavos): "3242000" → "32.420,00".
 * Aceita também texto já formatado.
 */
export function mascararMoedaDigitando(raw) {
  const digits = String(raw ?? "").replace(/\D/g, "");
  if (!digits) return "";
  const n = Number(digits) / 100;
  if (!Number.isFinite(n)) return "";
  return formatarMoedaInput(n);
}

/**
 * Máscara percentual enquanto digita: mantém dígitos + uma vírgula,
 * no máximo 2 casas decimais. Remove "%".
 */
export function mascararPctDigitando(raw) {
  let s = String(raw ?? "")
    .replace("%", "")
    .replace(/[^\d,]/g, "");
  if (!s) return "";

  const primeiro = s.indexOf(",");
  if (primeiro >= 0) {
    s =
      s.slice(0, primeiro + 1) +
      s.slice(primeiro + 1).replace(/,/g, "");
    const [intPart, decPart = ""] = s.split(",");
    s = `${intPart},${decPart.slice(0, 2)}`;
  }

  return s;
}

export function formatarCampoTributaria(chave, valorNumerico) {
  if (chave === "taxa_20s") return formatarPctInput(valorNumerico);
  return formatarMoedaInput(valorNumerico);
}

export function mascararCampoTributaria(chave, raw) {
  if (chave === "taxa_20s") return mascararPctDigitando(raw);
  return mascararMoedaDigitando(raw);
}
